<template>
    <ContentComponentItem
        v-for="(component, key) in data"
        :key="key"
        :background="background"
        :has-eager-image="hasEagerImage"
        :data="component"
        :page-type="pageType"
    />
</template>

<script setup lang="ts">
import type { Color, ContentComponentItemFragment } from '@/graphql/api'
import ContentComponentItem from '@/components/cms/component/ContentComponentItem.vue'
import type { PageType } from '@/components/cms/component/content/ContentButton.vue'

defineProps<{
    data?: ContentComponentItemFragment[]
    background?: Color
    hasEagerImage?: boolean
    pageType: PageType
}>()
</script>
